import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
const GAP = 10;
export default React.memo(function Tooltip({ children = null, text = '', color = 'dark', textAlign = 'center', className, vPosition = 'bottom', hPosition = 'right', }) {
    const tooltipEl = React.useRef(null);
    const onMouseMove = (e) => {
        if (hPosition === 'right') {
            tooltipEl.current.style.left = `${e.pageX - pageXOffset + GAP}px`;
        }
        else {
            tooltipEl.current.style.right = `${window.innerWidth - e.pageX + pageXOffset + GAP}px`;
        }
        if (vPosition === 'bottom') {
            tooltipEl.current.style.top = `${e.pageY - pageYOffset + GAP}px`;
        }
        else {
            tooltipEl.current.style.bottom = `${window.innerHeight - e.pageY + pageYOffset + GAP}px`;
        }
    };
    const onMouseOver = (e) => {
        tooltipEl.current.style.display = `block`;
    };
    const onMouseLeave = (e) => {
        tooltipEl.current.style.display = `none`;
    };
    let _text = text;
    _text = _text.replace(/<purple>/, `<span style='color: var(--colors-purple)'>`);
    _text = _text.replace(/<\/purple>/, `</span>`);
    _text = _text.replace(/<orange>/, `<span style = 'color: var(--colors-orange)'> `);
    _text = _text.replace(/<\/orange>/, `</span> `);
    const Tooltip = styled.div `
    display: none;
    position: fixed;
    border-radius: 4px;
    background-color: var(--bg-100);
    color: var(--text-secondary);
    padding: 0.20rem 0.4rem 0.15rem 0.4rem;
    font-size: 0.75rem;
    text-align: ${p => p.textAlign};
    line-height: 1.2rem;
    z-index: 100;

    ${props => props.color === 'blue' && css `
        background: var(--ui-accent-color);
        color: var(--text-primary);
    `}
`;
    return (_jsxs("span", { onMouseMove: onMouseMove, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, className: "tooltip-item", children: [children, _jsx(Tooltip, { className: className, color: color, textAlign: textAlign, ref: tooltipEl, dangerouslySetInnerHTML: { __html: _text } })] }));
});
